import { useMemo } from 'react'

export default function GroupIndividualWorkoutCompletionLinearFill({
    isDateAfterClientISOWeek = false,
    kinesisWorkoutCalendarItemData = null,
    kinesisGroupIndividualWorkoutCalendarItemData = [],
    kinesisProfileDetails = null
}) {

    // console.log(kinesisWorkoutCalendarItemData)
    // console.log(kinesisGroupIndividualWorkoutCalendarItemData)

    const name = kinesisWorkoutCalendarItemData.name
    const date = kinesisWorkoutCalendarItemData.date

    const CountNumberOfCompletedGroupIndividualWorkoutsOnGivenDate = () => {
        return kinesisGroupIndividualWorkoutCalendarItemData.filter((item) => (item.name === name && item.date === date && item.completed === 1)).length
    }

    const CountNumberOfAssignedGroupIndividualWorkoutsOnGivenDate = () => {
        return kinesisGroupIndividualWorkoutCalendarItemData.filter((item) => (item.name === name && item.date === date)).length
    }

    const completedCount = useMemo(() => CountNumberOfCompletedGroupIndividualWorkoutsOnGivenDate(), [date])
    
    const assignedCount = useMemo(() => CountNumberOfAssignedGroupIndividualWorkoutsOnGivenDate(), [date])

    // Future week display. Just show 0 out of the current number of group athletes

    if (isDateAfterClientISOWeek) {
        return (
            <div className='py-1 relative'>
                <div className='h-4 w-full bg-white rounded-full border border-gray-400 relative overflow-hidden p-[1px]'>
                    <div
                        className='h-full bg-orange-300 rounded-full'
                        style={{
                            width: `${ assignedCount ? (completedCount / assignedCount) * 100 : 0 }%`
                        }}
                    />
                </div>

                <p className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-600 text-xxs font-bold'>
                    0/{kinesisProfileDetails?.groupAthleteCount ?? 0}
                </p>
            </div>
        )
    }

    // For past and present weeks, show the completion percentage and the number of completed and assigned workouts

    if (assignedCount === 0) {
        return (
            <div className='py-1 relative'>
                <div className='h-4 w-full bg-white rounded-full border border-gray-400 relative overflow-hidden p-[1px]'>
                    <div
                        className='h-full bg-orange-300 rounded-full'
                        style={{
                            width: `${ assignedCount ? (completedCount / assignedCount) * 100 : 0 }%`
                        }}
                    />
                </div>

                <p className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-600 text-xxs font-bold'>
                    None
                </p>
            </div>
        )
    }
    
    return (
        <div className='py-1 relative'>
            <div className='h-4 w-full bg-white rounded-full border border-gray-400 relative overflow-hidden p-[1px]'>
                <div
                    className='h-full bg-orange-300 rounded-full'
                    style={{
                        width: `${ assignedCount ? (completedCount / assignedCount) * 100 : 0 }%`
                    }}
                />
            </div>

            <p className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gray-600 text-xxs font-bold'>
                {completedCount}/{assignedCount}
            </p>
        </div>
    )
}